<template>
    <q-page class="">
        <p class="q-display-1">Komunikaty głosowe</p>

        Brak implementacji

        <voice-command-item :model="vc" v-for="(vc, index) in $store.state.voicecommands" :key="index"/>
    </q-page>
</template>

<script>
    import VoiceCommandItem from './VoiceCommandItem'

    export default {
        name: 'VoiceCommands',
        components: {VoiceCommandItem},
        mounted () {

        },
    }
</script>

<style scoped lang="scss">

</style>